import type { FC } from 'react';
import { LessonSection } from '@/Module/Lesson/Component';
import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';
interface ILessonRelatedProps {
  ids: ILessonSection['id'][];
}
const LessonRelatedDesktop: FC<ILessonRelatedProps> = ({
  ids
}) => {
  return <div className="relative before:absolute before:bottom-0 before:left-0 before:z-10 before:h-1/4 before:w-full before:bg-gradient-to-t before:from-white before:ring-0 before:transition-all before:duration-300 before:ease-in-out before:content-[''] hover:before:h-0" data-sentry-component="LessonRelatedDesktop" data-sentry-source-file="LessonRelatedDesktop.tsx">
      <div dir="ltr" className="viewerSidebar mb-12 mr-[-1.5rem] flex h-1/4 max-h-[715px] flex-col overflow-x-auto pr-6 ">
        {ids.map((id, index) => <LessonSection id={id} key={id} className="mb-4" index={index + 1} isRelated />)}
      </div>
    </div>;
};
export default LessonRelatedDesktop;